import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

import { NewsService, StoreService, DialogsService, StorageService } from '@services';
import { News, Store } from '@models';
import { IBitfApiResponse, IBitfApiPagination, IBitfPaginatorOptions } from '@interfaces';
import { eStoreActions, EBitfPQueryComparators, EBitfPQueryOperator } from '@enums';
import { NewsDialogComponent } from '../news-dialog/news-dialog.component';

@Component({
  selector: 'prada-news-container',
  templateUrl: './news-container.component.html',
  styleUrls: ['./news-container.component.scss'],
})
export class NewsContainerComponent implements OnInit {
  news: News[] = [];
  visibleNews: News[] = [];
  pagination: IBitfApiPagination;
  paginatorOptions: IBitfPaginatorOptions = {
    hidePageSize: true,
    paginatorClass: 'prada-light-gray-bg',
  };
  constructor(
    private newsService: NewsService,
    private storeService: StoreService,
    private storageService: StorageService,
    private dialogsService: DialogsService
  ) {
    this.pagination = {
      ...this.pagination,
      size: 3,
      page: 0,
    };
  }

  ngOnInit() {
    this.setNumberOfItems(this.storeService.store);
    this.storeService.selectStore(eStoreActions.BREAKPOINT).subscribe(event => {
      this.setNumberOfItems(event.store);
    });

    this.newsService
      .list<News>({
        query: [
          {
            name: 'publishedFrom',
            value: new Date(),
            comparator: EBitfPQueryComparators.LOWEREQUAL,
            conjunction: EBitfPQueryOperator.AND,
          },
          {
            name: 'publishedTo',
            value: new Date(),
            comparator: EBitfPQueryComparators.GREATEREQUAL,
            conjunction: EBitfPQueryOperator.AND,
          },
        ],
      })
      .subscribe((response: IBitfApiResponse<News[]>) => {
        this.news = response.content;
        this.updateSlideshow(0);
        const highlightNews = this.news.filter(
          item =>
            item.showPopup === true &&
            this.storageService.data.readNewsIds &&
            !this.storageService.data.readNewsIds.find(value => value === item.id)
        );
        if (highlightNews.length > 0) {
          this.showPopup(highlightNews);
        }
      });
  }

  onPageChange(event: PageEvent) {
    this.updateSlideshow(event.pageIndex);
  }

  onNewsClick(news: News) {
    this.showPopup([news], false);
  }

  private showPopup(news: News[], highlight = true) {
    this.dialogsService.dialog.open(NewsDialogComponent, {
      width: 'auto',
      minWidth: '500px',
      maxWidth: '600px',
      height: 'auto',
      minHeight: '400px',
      maxHeight: '90%',
      panelClass: 'overflow-y-scroll',
      data: {
        highlight,
        news,
      },
    });
  }

  private setNumberOfItems(event: Store) {
    this.pagination.size = event.activeBreakpoints.isMobile ? 1 : 3;
    this.updateSlideshow(0);
  }

  private updateSlideshow(pageIndex: number) {
    this.pagination.totalItems = this.news.length;
    this.pagination.page = pageIndex;
    const startIndex = pageIndex * this.pagination.size;
    const endIndex = startIndex + this.pagination.size;
    this.visibleNews = this.news.slice(startIndex, endIndex);
  }
}
